import { NatureOfBusiness } from '../models/nature-of-business';

export class NatureOfBusinessData {
    private natureOfBusinessList: NatureOfBusiness[] = [new NatureOfBusiness('Architecture/Engineering', ['Administrative Assistant/Secretary/Receptionist',
        'Aerospace Engineer',
        'Agricultural engineer',
        'Architect',
        'Architectural/Engineering Manager',
        'Bill and Account Collector',
        'Biomedical engineer',
        'Drafter',
        'Bookkeeping, Accounting, Auditing Clerk',
        'Cartographer/photogrammetrist',
        'Chemical Engineer',
        'Civil Engineer ',
        'Civil Engineer Technician',
        'Computer hardware engineer',
        'Customer Service Representative',
        'Electrical and electronics engineer',
        'Electro-mechanical Technician',
        'Environmental Engineer',
        'Environmental Engineering Technician',
        'Financial Clerk',
        'Health and Safety Engineer',
        'Industrial Engineer',
        'Industrial Engineering Technician',
        'Industrial Production Manager',
        'Landscape Architect',
        'Marine Engineer and Naval Architect',
        'Materials Engineer',
        'Mechanical Engineer',
        'Mechanical Engineering Technician',
        'Mining and Geological Engineer',
        'Nuclear Engineer',
        'Operations Technician',
        'Petroleum Engineer',
        'Quality Assurance Specialist',
        'Surveying and Mapping Technician',
        'Surveyor']),
    new NatureOfBusiness('Arts/Design', ['Actor/Actress',
        'Administrative Assistant/Secretary/Receptionist',
        'Art Director',
        'Bill and Account Collector',
        'Bookkeeping, Accounting, Auditing Clerk',
        'Craft and Fine Artist',
        'Customer Service Representative',
        'Dancer',
        'Fashion Designer',
        'Floral Designer',
        'Graphic Designer',
        'Industrial Designer',
        'Interior Designer',
        'Model',
        'Multimedia Artists and Animator']),
    new NatureOfBusiness('Business, Non-Finance', ['Accountant/Auditor',
        'Actuary',
        'Administrative Assistant/Secretary',
        'Administrative Services Manager',
        'Advertising Sales Agent',
        'Advertising, Promotions, Marketing Manager',
        'Appraiser/Assessor of Real Estate',
        'Claims Adjuster, Appraiser, Examiner, Investigator',
        'Bill and Account Collector',
        'Board Member',
        'Bookkeeping, Accounting, Auditing Clerk',
        'Budget Analyst',
        'Business Development Specialist',
        'Buyer/Purchasing Agent',
        'Cashier',
        'Compensation, Benefits, and Job Analysis Specialist',
        'Compensation/Benefits Manager',
        'Computer and Information Systems Manager',
        'Cost Estimator',
        'Customer Service Representative',
        'Desktop Publisher',
        'Director',
        'Emergency Management Director',
        'Executive Vice President',
        'Financial Analyst',
        'Financial Clerk',
        'Financial Examiner',
        'Financial Managers',
        'Fundraiser',
        'General Manager',
        'Hotel/Lodging Manager',
        'Human Resources Manager',
        'Human Resources Specialist',
        'Insurance Sales Agent',
        'Insurance Underwriter',
        'Labor Relations Specialist',
        'Loan Officer',
        'Management Analyst',
        'Market Research Analyst',
        'Mathematician',
        'Meeting, Convention, or Event Planner',
        'Operations Research Analyst',
        'Personal Financial Advisor',
        'President',
        'Property/Real Estate/Community Association Manager',
        'Public Relations/Fundraising Manager',
        'Public Relations/Fundraising Specialist',
        'Purchasing Manager',
        'Quality Assurance Specialist',
        'Real Estate Broker/Sales Agent',
        'Retail Sales Worker',
        'Sales Engineer',
        'Sales Manager',
        'Senior Vice President',
        'Statistician',
        'Tax Examiner/Collector/Revenue Agent',
        'Training and Development Manager',
        'Training and Development Specialist',
        'Travel Agent',
        'Vice President',
        'Wholesale and Manufacturing Sales Representative',
        'Arms Manufacturer or Dealer',
        'Oil/Gas/Mininig business Director',
        'Charity Director',
        'Religious Organisation Worker',
        'Adult Entertainment Online Portal Worker',
        'Dealer of the Exotic Goods eg. Porcelain, historic arterfacts',
        'Asian Clothing Manufacturer']),
    new NatureOfBusiness('Community/Social Service', ['Administrative Assistant/Secretary/Receptionist',
        'Bill and Account Collector',
        'Bookkeeping, Accounting, Auditing Clerk',
        'Customer Service Representative',
        'Desktop Publisher',
        'Emergency Management Director',
        'Financial Clerk',
        'Social and Human Service Assistant',
        'Health Educator/Community Health Worker',
        'Mental Health Counselor/ Marriage and Family Therapist',
        'Probation Officer/Correctional Treatment Specialist',
        'Quality Assurance Specialist',
        'Rehabilitation Counselor',
        'School/Career Counselor',
        'Social and Community Service Manager',
        'Social Worker',
        'Substance Abuse and Behavioral Disorder Counselor']),
    new NatureOfBusiness('Computer/Information Technology', ['Administrative Assistant/Secretary/Receptionist',
        'Bill and Account Collector',
        'Bookkeeping, Accounting, Auditing Clerk',
        'Computer and Information Research Scientist',
        'Computer Network Architect',
        'Computer Programmer',
        'Computer Support Specialist',
        'Quality Assurance Specialist',
        'Computer Systems Analyst',
        'Customer Service Representative',
        'Database Administrator',
        'Desktop Publisher',
        'Financial Clerk',
        'Information Security Analyst',
        'Network and Computer Systems Administrator',
        'Software Developer',
        'Web Developer']),
    new NatureOfBusiness('Construction/Extraction', ['Administrative Assistant/Secretary/Receptionist',
        'Bill and Account Collector',
        'Boilermaker',
        'Bookkeeping, Accounting, Auditing Clerk',
        'Carpenter',
        'Construction Equipment Operator',
        'Construction Manager',
        'Glazier',
        'Construction/Building Inspector',
        'Customer Service Representative',
        'Drywall/Ceiling Tile Installer, or Taper',
        'Electrician',
        'Elevator Installer/Repairer',
        'Financial Clerk',
        'Flooring Installer/Tile and Marble Setter',
        'Hazardous Materials Removal Worker',
        'Heavy Machinery Operator',
        'Insulation Worker',
        'Ironworker',
        'Masonry Worker',
        'Painter, Construction and Maintenance',
        'Plumber, Pipefitter, Steamfitter',
        'Quality Assurance Specialist',
        'Roofer',
        'Sheet Metal Worker',
        'Solar Photovoltaic Installer']),
    new NatureOfBusiness('Education/Training/Library', ['Administrative Assistant/Secretary/Receptionist',
        'Adult Literacy and High School Equivalency Diploma Teacher',
        'Archivist, Curator, Museum Worker',
        'Bill and Account Collector',
        'Bookkeeping, Accounting, Auditing Clerk',
        'Career and Technical Education Teacher',
        'Customer Service Representative',
        'Middle School Teacher',
        'Elementary/Middle/High School Principal',
        'Financial Clerk',
        'High School Teacher',
        'Instructional Coordinator',
        'Kindergarten/Elementary School Teacher',
        'Librarian',
        'Library Technician/Assistant',
        'Postsecondary Education Administrator',
        'Postsecondary Teacher',
        'Preschool Teacher',
        'Preschool/Childcare Center Director',
        'Special Education Teacher',
        'Teacher Assistant']),
    new NatureOfBusiness('Farming, Fishing and Forestry', ['Administrative Assistant/Secretary/Receptionist',
        'Agricultural Worker',
        'Bill and Account Collector',
        'Bookkeeping, Accounting, Auditing Clerk',
        'Customer Service Representative',
        'Farmers, Ranchers, Other Agricultural Manager',
        'Fishing/Hunting Worker',
        'Forest/Conservation Worker',
        'Logging Worker',
        'Quality Assurance Specialist',
        'Asian Fishing Worker']),
    new NatureOfBusiness('Finance/Broker Dealer (407 flag)', ['Accountant/Auditor',
        'Actuary',
        'Administrative Assistant/Secretary/Receptionist',
        'Administrative Services Manager',
        'Advertising Sales Agent',
        'Advertising, Promotions, and Marketing Manager',
        'Appraiser/Assessor ',
        'Claims Adjuster, Appraiser, Examiner, Investigator',
        'Bill and Account Collector',
        'Board Member',
        'Bookkeeping, Accounting, Auditing Clerk',
        'Budget Analyst',
        'Business Development Specialist',
        'Buyer/Purchasing Agent',
        'Cashier',
        'Compensation, Benefits, and Job Analysis Specialist',
        'Compensation/Benefits Manager',
        'Computer and Information Research Scientist',
        'Computer and Information Systems Managers',
        'Computer Network Architect',
        'Computer Programmer',
        'Computer Support Specialist',
        'Computer Systems Analyst',
        'Cost Estimator',
        'Customer Service Representative',
        'Database Administrator',
        'Desktop Publisher',
        'Director',
        'Executive Vice President',
        'Financial Analyst',
        'Financial Clerk',
        'Financial Examiner',
        'Financial Managers',
        'Fundraiser',
        'General Manager',
        'Human Resources Manager',
        'Human Resources Specialist',
        'Information Security Analyst',
        'Insurance Underwriter',
        'Labor Relations Specialist',
        'Loan Officer',
        'Management Analyst',
        'Market Research Analyst',
        'Mathmetician',
        'Meeting, Convention, or Event Planner',
        'Network and Computer Systems Administrator',
        'Operations Research Analyst',
        'Other',
        'Personal Financial Advisor',
        'President',
        'Property/Real Estate/Community Association Manager',
        'Public Relations/Fundraising Manager',
        'Public Relations/Fundraising Specialist',
        'Quality Assurance Specialist',
        'Sales Engineer',
        'Sales Manager',
        'Securities, Commodities, Financial Services Sales Agent',
        'Senior Vice President',
        'Software Developer',
        'Statistician',
        'Tax Examiner/Collector/Revenue Agent',
        'Teller',
        'Training and Development Manager',
        'Training and Development Specialist',
        'Vice President',
        'Web Developer',
        'Remittance House Director',
        'Exchange House Director',
        'Bureau de Change Director',
        'Money Transfer Director',
        'Casino Manager',
        'Cryptocurrency Specialist']),
    new NatureOfBusiness('Food Preparation and Servicing', ['Bartender',
        'Administrative Assistant/Secretary/Receptionist',
        'Bill and Account Collector',
        'Chef/Head Cook',
        'Cook',
        'Customer Service Representative',
        'Financial Clerk',
        'Food and Beverage Serving and Related Worker',
        'Food Preparation Worker',
        'Food Service Manager',
        'Quality Assurance Specialist',
        'Waiter/Waitress']),
    new NatureOfBusiness('Healthcare', ['Athletic Trainer',
        'Bill and Account Collector',
        'Bookkeeping, Accounting, Auditing Clerk',
        'Dental Assistant',
        'Dental Hygienist',
        'Dentist',
        'Dietitian/ Nutritionist',
        'Financial Clerk',
        'Administrative Assistant/Secretary/Receptionist',
        'Customer Service Representative',
        'Chiropractor',
        'Audiologist',
        'Diagnostic Medical Sonographer/Cardiovascular Technologist/Technicians, Including Vascular Technologist',
        'EMT/Paramedic',
        'Exercise Physiologist',
        'Genetic Counselor',
        'Home Health Aide',
        'Licensed Practical/Vocational Nurse',
        'Massage Therapist',
        'Medical Assistant',
        'Medical Records/Health Information Technician',
        'Medical Transcriptionist',
        'Medical/Clinical Laboratory Technologist/Technician',
        'Medical/Health Services Manager',
        'Nuclear Medicine Technologist',
        'Nurse Anesthetists, Nurse Midwife, Nurse Practitioner',
        'Nursing Assistant/Orderly',
        'Occupational Health and Safety Specialist',
        'Occupational Health and Safety Technician',
        'Occupational Therapist',
        'Occupational Therapy Assistant/Aide',
        'Optician',
        'Optometrist',
        'Orthotist/Prosthetist',
        'Pharmacist',
        'Pharmacy Technician',
        'Phlebotomist',
        'Physical Therapist',
        'Physical Therapist Assistant/Aide',
        'Physician Assistant',
        'Physician/Surgeon',
        'Podiatrist',
        'Psychiatric Technician/Aide',
        'Quality Assurance Specialist',
        'Radiation Therapist',
        'Radiologic/MRI Technologist',
        'Recreational Therapist',
        'Registered Nurse',
        'Respiratory Therapist',
        'Speech-Language Pathologist',
        'Surgical Technologist',
        'Veterinarian',
        'Veterinary Assistant/Laboratory Animal Caretaker',
        'Veterinary Technologist/Technician']),
    new NatureOfBusiness('Installation, Maintenance, and Repair', ['Aircraft and Avionics Equipment Mechanic/Technician',
        'Automotive Service Technician/Mechanic',
        'Bill and Account Collector',
        'Electrical and Electronics Installer/Repairer',
        'General Maintenance/ Repair Worker',
        'Heating, Air Conditioning, and Refrigeration Mechanic/Installer',
        'Industrial Machinery Mechanics, Machinery Maintenance Worker/Millwright',
        'Quality Assurance Specialist',
        'Administrative Assistant/Secretary/Receptionist',
        'Diesel Service Technician/Mechanic',
        'Customer Service Representative',
        'Automotive Body and Glass Repairer',
        'Heavy Vehicle and Mobile Equipment Service Technicians',
        'Line Installer/Repairer',
        'Medical Equipment Repairer',
        'Small Engine Mechanic',
        'Telecommunications Equipment Installer/Repairer',
        'Wind Turbine Technician']),
    new NatureOfBusiness('Legal', ['Administrative Assistant/Secretary/Receptionist',
        'Arbitrator, Mediator, Conciliator',
        'Bill and Account Collector',
        'Court Reporter',
        'Judge/Hearing Officer',
        'Lawyer',
        'Paralegal/Legal Assistant']),
    new NatureOfBusiness('Life, Physical and Social Science', ['Agricultural/Food Science Technician',
        'Anthropologist/Archeologist',
        'Atmospheric Scientist/Meteorologist',
        'Biological Technician',
        'Chemical Technician',
        'Chemist/Materials Scientist',
        'Customer Service Representative',
        'Environmental Scientist/Specialist',
        'Administrative Assistant/Secretary/Receptionist',
        'Biochemist/Biophysicist',
        'Bill and Account Collector',
        'Agricultural/Food Scientist',
        'Conservation Scientist/Forester',
        'Economist',
        'Environmental Science/Protection Technician',
        'Epidemiologist',
        'Forensic Science Technician',
        'Geographer',
        'Geological/ Petroleum Technician',
        'Geoscientist',
        'Historian',
        'Hydrologist',
        'Medical Scientist',
        'Microbiologist',
        'Natural Sciences Manager',
        'Nuclear Technician',
        'Physicist/Astronomer',
        'Political Scientist',
        'Psychologist',
        'Quality Assurance Specialist',
        'Sociologist',
        'Survey Researcher',
        'Urban/Regional Planner',
        'Zoologist/Wildlife Biologist']),
    new NatureOfBusiness('Media and Communications', ['Administrative Assistant/Secretary/Receptionist',
        'Announcer',
        'Bill and Account Collector',
        'Broadcast/Sound Engineering Technician',
        'Customer Service Representative',
        'Desktop Publisher',
        'Editor',
        'Film/Video Editor, Camera Operator',
        'Interpreter/Translator',
        'Photographer',
        'Public Relations Specialist',
        'Reporter, Correspondent, and Broadcast News Analyst',
        'Technical Writer',
        'Writer/Author']),
    new NatureOfBusiness('Military/Law Enforcement, Government, Protective Service', ['Correctional Officer/Bailiff',
        'Financial Clerk',
        'Fire Inspector',
        'Firefighter',
        'General Office Clerk',
        'Information Clerk',
        'Material Recording Clerk',
        'Military Personnel',
        'Police/Detective',
        'Postal Service Worker',
        'Private Detective/Investigator',
        'Public Safety Telecommunicator',
        'Security Guard/Gaming Surveillance Officer']),
    new NatureOfBusiness('Personal Care/Service', ['Animal Care/Service Worker',
        'Barber, Hairdresser, Cosmetologist',
        'Childcare Worker',
        'Fitness Trainer/Instructor',
        'Funeral Service Worker',
        'Gaming Services Workers',
        'Manicurist/Pedicurist',
        'Personal Care Aide',
        'Recreation Worker',
        'Skincare Specialist',
        'Animal welfare Worker eg. Livestock logisticks, fur seller']),
    new NatureOfBusiness('Production', ['Baker',
        'Dental and Ophthalmic Laboratory Technician/ Medical Appliance Technician',
        'Food and Tobacco Processing Worker',
        'Metal/Plastic Machine Worker',
        'Painting and Coating Worker',
        'Power Plant Operator, Distributos, Dispatcher',
        'Stationary Engineer/Boiler Operator',
        'Woodworker',
        'Assembler/Fabricator',
        'Machinist/Tool and Die Maker',
        'Jeweler and Precious Stone/ Metal Worker',
        'Butcher',
        'Quality Control Inspector',
        'Water and Wastewater Treatment Plant and System Operator',
        'Welder, Cutter, Solderer, and Brazer',
        'Antique Dealer',
        'Auction House Worker']),
    new NatureOfBusiness('Transportation and Material Moving', ['Air Traffic Controller',
        'Airline and Commercial Pilot',
        'Bus Driver',
        'Delivery Truck Driver and Driver/Sales Worker',
        'Flight Attendant',
        'Hand Laborer/Material Mover',
        'Heavy and Tractor-trailer Truck Driver',
        'Material Moving Machine Operator',
        'Railroad Worker',
        'Taxi Driver/Chauffeur',
        'Water Transportation Worker']),
    new NatureOfBusiness('Other', [])];
    getNatureOfBusinessList(): Array<NatureOfBusiness> {
        return this.natureOfBusinessList;
    }

    findNatureNameByBusinessName(businessName: string): string {
        let tempName: string;
        this.natureOfBusinessList.forEach(nat => {
            nat.businessList.forEach(bus => {
                if (bus === businessName) {
                    tempName = nat.natureName;
                }
            });
        });
        return tempName;
    }
}
